<template>
    <div id="confirmMail">
        <patternlib-headline :headline="$t('confirmMail.headline')" heading-tag="h2" separator="none" />
        <p>{{ $t("confirmMail.text") }}</p>
        <div id="confirmCode">
            <patternlib-textinput 
                :label="$t('confirmMail.confirmationCode')"
                @lhChange="(e) => {confirmCode = e.detail.value}"
            />
            <patternlib-button 
                :label="$t('confirmMail.confirm')"
                @click="() => {confirmMail()}"
                :loading="loading"
            />
        </div>
    </div>
</template>

<script>
import { useServices } from '../services/useServices';

export default {
    data: () => ({
        confirmCode: "",
        loading: false
    }),

    methods: {
        confirmMail() {
            this.loading = true
            const services = useServices()
            services.$api.confirmMail((redirectUri) => {
                if (redirectUri) {
                    services.$registration.clearData()
                    window.location.replace(redirectUri)
                    return
                }
                this.loading = false
                this.$emit("showMessage", {
                    type: "alert",
                    showIcon: true,
                    message: this.$t("unknownError")
                })
            }, services.$registration.getSessionId(), this.confirmCode)
        }
    },

    created() {
        const services = useServices()
        if (!services.$registration.waitingForConformation()) {
            this.$router.push("/register")
        }
    }
}
</script>

<style lang="scss" scoped>
#confirmMail {
    margin: 64px;
}

#confirmCode {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-5);
    align-items: flex-end;
}

#confirmCode > patternlib-textinput {
    width: 100%;
}
@media only screen and (max-width: 770px) { 
    #confirmCode {
        flex-direction: column;
    }

    #confirmCode > patternlib-button {
        width: 100%;
    }
}
</style>